import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthUser } from '@core/models/auth-user.model';
import { ErrorMessages } from '@shared/models/error-messages.model';

@Component({
  selector: 'fdx-login-form',
  templateUrl: './login-form.component.html'
})
export class LoginFormComponent implements OnInit {
  @Output() submitForm = new EventEmitter<AuthUser>();
  @Input() errorMessages: ErrorMessages;

  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  get emailHasErrors(): boolean {
    return (
      this.form &&
      !!this.form.get('mail').invalid &&
      !this.form.get('mail').untouched
    );
  }

  get passwordHasErrors(): boolean {
    return (
      this.form &&
      !!this.form.get('password').invalid &&
      !this.form.get('password').untouched
    );
  }

  get isEmailRequired(): boolean {
    return !!this.form.get('mail').hasError('required');
  }

  get isFormatInvalid(): boolean {
    return !!this.form.get('mail').hasError('email');
  }

  get isPasswordRequired(): boolean {
    return !!this.form.get('password').hasError('required');
  }

  get isInvalidForm(): boolean {
    return this.form.invalid;
  }

  onClickSubmit(): void {
    this.submitForm.emit(this.form.value);
  }

  private initForm(): void {
    this.form = this.fb.group({
      mail: [null, [Validators.email, Validators.required]],
      password: [null, Validators.required]
    });
  }
}
